import React, { Fragment, useState, useEffect } from 'react';
import {setAppCustomTitle} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import {Modal, ModalBody, ModalHeader,
} from 'reactstrap';
import { modalHeaders } from './constants';
import Calendar from './Calendar';
import { getSessionValue,showToast, translateContent, handleErrorResponse,checkIntegrationStatus } from '../../Common/Appcommon';
import requestApi from '../../services/requestApi.service';
import SendEmailSMSAction from './SendEmailSMS';
import CallTransfer from './CallTransfer';
import CallEnd from './CallEnd';
import ExtractInfo from './ExtractInfo';
import Voicemail from './Voicemail';
import CustomeAction from './CustomAction';
import Loading from '../../Common/Loading';
import ServerInfo from './ServerInfo';


const ActionModal = (props) => {
    const { isOpen, toggle, currentAction, agent_id, getAgentAction, actionId, onAction, rowData ,selectedAgentDetails, onChange, onSubmit } = props;
    const [modalHeaderDetails, setHeaderDetails] = useState({ header: "", description: "", warning: "" });
    const [showLoading,setShowLoading] = useState(false);
    const [isShowAlert,setShowAlert] = useState({send_sms : false, send_email: false});
    
    useEffect( async () =>  {
        if (currentAction) {
            const headerDetails = modalHeaders[currentAction];
            setHeaderDetails({
                header: headerDetails !== undefined && headerDetails !== null && headerDetails[0]?.header || "",
                description: headerDetails !== undefined && headerDetails !== null && headerDetails[0]?.description || "",
                warning: headerDetails !== undefined && headerDetails !== null && headerDetails[0]?.warning || ""
            });
            let data = await checkIntegrationStatus();
            setShowAlert({
                send_sms: data.includes('twilio'),
                send_email: data.includes('email')
            });
        }
    }, [currentAction]);
    
    const saveActionDetails = async (inputData, action_name, action_type = "", onaction = "") => {
        setShowLoading(true);
        let curUser = getSessionValue('loginusername');
        let params = {
            "ENTITY": "AIPROCESSOR",
            "OPERATION": "SAVE_ACTION_DETAILS",
            "action_details": inputData,
            "action_name":action_name,
            "action_type": action_type,
            "onaction":onaction,
            'status': 'active',
            'updatedusername': curUser,
            'agent_id': agent_id,
            'action_id':actionId,
            'provider':getSessionValue('agent_provider_name')
        };
        let response = await requestApi.processServerRequest(params);
        setShowLoading(false)
        if(response.issuccess){
            showToast(translateContent("vm.agents.actions.success"));
            toggle(true);
            await getAgentAction(onaction);
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const handleToggle = () =>{
        if(showLoading){
            return;
        }
        toggle();
    }
    const getDesiredComponent = (currentAction = "") => {
        if (currentAction === "book_calendar") {
            return (
                <Fragment>
                    <Calendar
                        agent_id={agent_id}
                        saveDetails={saveActionDetails} 
                        actionId={actionId}
                    />
                </Fragment>
            );
        }else if(currentAction === "send_sms" || currentAction === "send_email") {
            return (
                <SendEmailSMSAction
                    type={currentAction}
                    onAction={onAction}
                    agent_id={agent_id}
                    actionId={actionId}                    
                    saveDetails={saveActionDetails}
                    rowData={rowData}
                    isShowAlert={isShowAlert}
                />
            );
        }else if(currentAction === "transfer_call"){
            return (
                <Fragment>
                    <CallTransfer 
                        agent_id={agent_id}
                        details={selectedAgentDetails}
                        saveDetails={saveActionDetails} 
                        actionId={actionId}
                        onAction={onAction}
                    />
                </Fragment>
            )
        }else if(currentAction === "end_call"){
            return (
                <Fragment>
                    <CallEnd
                        agent_id={agent_id}
                        details={selectedAgentDetails}
                        saveDetails={saveActionDetails} 
                        actionId={actionId}
                        onAction={onAction}
                    />
                </Fragment>
            )
        }else if(currentAction === "extract_info"){
            return (
                <Fragment>
                    <ExtractInfo
                        agent_id={agent_id}
                        saveDetails={saveActionDetails} 
                        actionId={actionId}
                        onAction={onAction}
                        agentDetails = {selectedAgentDetails}
                    />
                </Fragment>
            )
        }else if(currentAction === "vmail_message"){
            return (
                <Fragment>
                    <Voicemail
                        agent_id={agent_id}
                        saveDetails={saveActionDetails} 
                        actionId={actionId}
                        onAction={onAction}
                    />
                </Fragment>
            )
        }else if (currentAction === "custom_action"){
            return (
                <Fragment>
                    <CustomeAction
                        agent_id={agent_id}
                        saveDetails={saveActionDetails} 
                        actionId={actionId}
                        onAction={onAction}
                        agentDetails = {selectedAgentDetails}
                    />
                </Fragment>
            )
        }else if(currentAction === "Post_Call_Event"){
            return (
                <Fragment>
                    <ServerInfo 
                        rowData={selectedAgentDetails}
                        onChange={onChange}
                        getSaveData={getAgentAction}
                        onAction={onAction}
                        toggle={toggle}
                    />
                </Fragment>
            )
        }else {
            toggle(); 
        }
    };
    

    const getModalContent = () => {
        return (
            <>
                <Modal className={'cal-action'} isOpen={isOpen}>
                    <ModalHeader toggle={() => handleToggle()}>
                        {modalHeaderDetails.header}
                        <div className='md-2 del-subaccount-header'>
                            {modalHeaderDetails.description}
                        </div>
                    </ModalHeader>
                    {(modalHeaderDetails.warning !== "" && !isShowAlert[currentAction]) && 
                        <div className='ms-2 me-2'>
                            <div className='main-card scrollable-table dns-error card w-75'>
                                <span className='del-subaccount-header  d-flex p-1 gap-2 align-items-center'><i class="fi fi-rr-exclamation dns-error-icon ms-2 align-items-center"></i>{modalHeaderDetails.warning}</span>
                            </div>
                        </div>
                    }
                    <ModalBody>                        
                        <Fragment>
                            <Loading showLoader={showLoading} mainContent={
                                getDesiredComponent(currentAction)
                            }/>
                        </Fragment>
                    </ModalBody>
                </Modal>
            </>
        );
    }

    return(
        <Fragment>
            {getModalContent()}
        </Fragment>
    )
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionModal);